import { BaseModel } from './BaseModel';

export interface Addon {
    name: string;
    display_name: string;
}

export class Addons extends BaseModel {
    [key: string]: any;

    get(name: string): Addon | undefined {
        if (this[name]) {
            return this[name];
        }
    }
}

export type AddonPlan = 'free' | 'community' | 'enterprise';

// One entry of the admin addon showcase: the commercial metadata WISP holds
// for an addon, plus what it unlocks here and whether it is active.
export class AddonCatalogEntry extends BaseModel {
    public name = '';
    public displayName = '';
    public description: string | null = null;
    public price = 0;
    public trialable = false;
    public plan: AddonPlan | null = null;
    public active = false;
    public requiresUpgrade = false;
    public billingUrl: string | null = null;
    public featureCount = 0;
    public tags: string[] = [];
    public included: string[] = [];
    public toggleable = false;

    getRouteID(): string {
        return this.name;
    }
}
